import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ClearTheChartsContext } from '../ClearTheChartsContext'
import { ChartTypes } from './ChartTypes/ChartTypes'

const Resume = ({
  setSelectedFilters,
  selectedFilters,
  setGameMode,
  setFiltersMode,
}) => {
  const { state } = useContext(ClearTheChartsContext)
  const [chartsToShow, setChartsToShow] = useState([])
  const { preflopCharts, currentChartProgress } = state

  useEffect(() => {
    const chartsToShow = Object.entries(currentChartProgress).reduce(
      (acc, curr) => {
        const [chartId, currentProgress] = curr
        const completedHands = currentProgress?.completedHands || {}
        if (!Object.keys(completedHands).length) return acc
        return [...acc, preflopCharts[chartId]]
      },
      [],
    )
    const sortedCharts = chartsToShow.sort((a, b) =>
      a.chartType.length > b.chartType.length ? 1 : -1,
    )
    setChartsToShow(sortedCharts)
  }, [preflopCharts, currentChartProgress])

  const Item = ({ item }) => {
    const { stackDepth, position, oppPosition, vsAction, chartType } = item

    const onClick = () => {
      setGameMode('tableResume')
      setFiltersMode('New Game')
      setSelectedFilters({
        chartType,
        stack: stackDepth,
        position,
        action: vsAction,
        oppos: oppPosition || '',
      })
      return
    }

    const cardStyle = {
      backgroundColor: '#ccc',
      borderRadius: 10,
      padding: '4px 5px',
      margin: '0 0 0 10px',
      fontSize: '14px',
    }
    const hero = {
      background: 'linear-gradient(180deg, #F3AE1E 0%, #E27F0B 100%)',
      color: 'white',
      minWidth: '60px',
      textAlign: 'center',
    }
    const opponent = {
      backgroundColor: '#ccc',
      color: 'black',
      minWidth: '50px',
      textAlign: 'center',
    }
    return (
      <div
        onClick={onClick}
        className="ClearTheCharts__button"
        style={{
          width: '100%',
          minWidth: '100%',
          marginTop: '10px',
          cursor: 'pointer',
          border: 'none',
          position: 'relative',
        }}
      >
        <div
          className="ClearTheCharts__button-label"
          style={{
            fontSize: '16px',
            flexDirection: 'row',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <div style={{ minWidth: '50px' }}>{stackDepth}BB</div>
          <div style={{ ...cardStyle, ...hero }}>{position}</div>
          <div style={{ ...cardStyle, ...opponent }}>
            {oppPosition} {vsAction.toUpperCase().replace('VS', '')}
          </div>

        </div>
      </div>
    )
  }

  const filteredCharts = useMemo(() => {
    let type = selectedFilters.chartType
    if (type === 'CASH GAME') type = 'CASH GAME 8MAX'
    return chartsToShow.filter(
      (item) => item.chartType.toUpperCase() === type.toUpperCase(),
    )
  }, [selectedFilters.chartType, chartsToShow])

  return (
    <div>
      <ChartTypes
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <div
        style={{
          width: '100%',
          borderBottomWidth: '0.5px',
          borderStyle: 'solid',
          borderColor: 'rgba(0,0,0,0.2)',
          marginTop: '10px',
        }}
      />
      {filteredCharts.map((item) => {
        return <Item item={item} />
      })}
    </div>
  )
}

export default Resume
